import { render } from "./UpdateClubOutlay.vue?vue&type=template&id=72dbfd34"
import script from "./UpdateClubOutlay.vue?vue&type=script&lang=js"
export * from "./UpdateClubOutlay.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__